import { ogImageMeta } from "@/lib/seo/og-image";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { MediaAnalysisOverview } from "@/components/site/MediaAnalysisOverview";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-analysis")({
  head: () => ({
    meta: [
      { title: "Media Analysis & Media Intelligence | Perceptica" },
      {
        name: "description",
        content:
          "Perceptica's media analyses turn coverage into media intelligence - reputation analysis, crisis monitoring, competitive and employer brand analysis across SEE.",
      },
      { property: "og:title", content: "Media Analysis & Media Intelligence | Perceptica" },
      {
        property: "og:description",
        content:
          "Perceptica's media analyses turn coverage into media intelligence - reputation analysis, crisis monitoring, competitive and employer brand analysis across SEE.",
      },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Analysis & Media Intelligence | Perceptica" },
      { name: "twitter:description", content: "Perceptica's media analyses turn coverage into media intelligence - reputation analysis, crisis monitoring, competitive and employer brand analysis across SEE." },
      { property: "og:url", content: "https://perceptica.com/media-analysis" },
      ...ogImageMeta("en", "/media-analysis"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-analysis", service: { name: "Media analysis", description: "Perceptica media analysis for Southeast Europe.", serviceType: "Media analysis" }, collection: { name: "Media analysis services", description: "All Perceptica media analysis services" } }),
  }),
  component: MediaAnalysisLayout,
});

function MediaAnalysisLayout() {
  const { pathname } = useLocation();
  const isOverview = pathname === "/media-analysis" || pathname === "/bg/media-analysis";

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader transparentOverHero />
      <main id="main">
        {isOverview ? <MediaAnalysisOverview /> : <Outlet />}
      </main>
      <SiteFooter />
    </div>
  );
}